import {Injectable} from "@angular/core";
import {EdiInvalidIdentifier} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";
import {ApiService} from "@app/_services/api.service";

@Injectable({
    providedIn: "root"
})
export class EdiFileInvalidIdentifiersService extends TableOptionsService<EdiInvalidIdentifier> {
    constructor(public apiService: ApiService) {
        super();
        this.pageSize = 25;
        this.sortDirection = "desc";
        this.sortColumn = "type";
    }

    public override matches(element: EdiInvalidIdentifier, term: string) {
        return (
            element.type?.toLowerCase().includes(term.toLowerCase()) ||
            element.name?.toLowerCase().includes(term.toLowerCase()) ||
            element.value?.toLowerCase().includes(term.toLowerCase()) ||
            element.qualifier?.toLowerCase().includes(term.toLowerCase()) ||
            element.details?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
